import { Effect, Layer, Option } from 'effect';

import { CookieKeys, DefaultCookieOptions, ORDER_TOKEN_MAX_AGE } from '../../../config/cookies';

import { ErrorTag } from '@vs-shop/engine/data/error';
import {
  GetOrderTokenError,
  OrderToken as EngineOrderToken,
  SetOrderTokenError,
} from '@vs-shop/engine/service/orderToken/OrderToken';
import { CookiesStore } from '@vs-shop/engine/service/cookies/CookiesStore';

export { GetOrderTokenError, SetOrderTokenError };

const make = Effect.gen(function* () {
  const cookieService = yield* CookiesStore;
  const key = CookieKeys.ORDER_TOKEN;

  return {
    getToken: Effect.gen(function* () {
      const tokenValue = yield* cookieService.get(key).pipe(
        Effect.catchTags({
          [ErrorTag.CookieGetError]: (error) =>
            new GetOrderTokenError({
              message: `Failed to get order token: ${error.message}`,
              cause: error,
            }),
          [ErrorTag.CookieAccessError]: (error) =>
            new GetOrderTokenError({
              message: `Failed to access order cookies: ${error.message}`,
              cause: error,
            }),
        })
      );

      return Option.fromNullishOr(tokenValue);
    }),

    setToken: (token: string) =>
      Effect.gen(function* () {
        const cookieOptions = {
          ...DefaultCookieOptions,
          expires: new Date(Date.now() + ORDER_TOKEN_MAX_AGE * 1000),
        };

        yield* cookieService.set(key, token, cookieOptions).pipe(
          Effect.catchTags({
            [ErrorTag.CookieSetError]: (error) =>
              new SetOrderTokenError({
                message: `Failed to set order token: ${error.message}`,
                cause: error,
              }),
            [ErrorTag.CookieAccessError]: (error) =>
              new SetOrderTokenError({
                message: `Failed to access order cookies: ${error.message}`,
                cause: error,
              }),
          })
        );

        return;
      }),

    removeToken: Effect.gen(function* () {
      const cookieOptions = {
        path: '/',
      };

      return yield* cookieService.remove(key, cookieOptions).pipe(
        Effect.catchTags({
          [ErrorTag.CookieRemoveError]: (error) =>
            new SetOrderTokenError({
              message: `Failed to remove order token: ${error.message}`,
              cause: error,
            }),
          [ErrorTag.CookieAccessError]: (error) =>
            new SetOrderTokenError({
              message: `Failed to access order cookies: ${error.message}`,
              cause: error,
            }),
        })
      );
    }),
  };
});

export const OrderTokenLive = Layer.effect(EngineOrderToken, make);
EngineOrderToken.Live = OrderTokenLive;

export { EngineOrderToken as OrderToken };
